function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.493 8.99988H9.07771L14.0161 13.9383C14.2049 14.1271 14.5155 14.1424 14.7096 13.9596C15.919 12.8202 16.7508 11.2843 16.9949 9.55769C17.0368 9.26207 16.7915 8.99988 16.493 8.99988ZM15.9983 6.97488C15.7408 3.24175 12.7577 0.25863 9.02458 0.00113C8.73958 -0.0185575 8.49958 0.221755 8.49958 0.50738V7.49988H15.4924C15.778 7.49988 16.018 7.25988 15.9983 6.97488ZM6.99958 8.99988V1.58457C6.99958 1.28613 6.73739 1.04082 6.44208 1.08269C2.71802 1.60894 -0.128545 4.86238 0.00395502 8.76144C0.140205 12.7658 3.58802 16.0496 7.59427 15.9993C9.16927 15.9796 10.6246 15.4721 11.8211 14.6233C12.068 14.4483 12.0843 14.0849 11.8702 13.8708L6.99958 8.99988Z"
});

function SvgPiechart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#3D4B57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechart);
export default __webpack_public_path__ + "static/media/piechart.4793d451.svg";
export { ForwardRef as ReactComponent };